// @ts-ignore
__webpack_public_path__ = window.__TRANSPORT_WIDGET_GLOBAL_CONFIGURATION_DATA?.REACT_APP_ASSET_HOST || '/';

import './settings/localization/i18n';
import { LinearProgress } from '@material-ui/core';

import PointInit from '@app/PointInit';
import PointInitPersonalAccount from '@app/PointInitPersonalAccount';
import PointMenuWidget from '@app/PointMenuWidget';
import PointPrimaryLang from '@app/PointPrimaryLang';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { ReportHandler } from 'web-vitals';

import PointWidget from './app';
import PointCurrency from './app/PointCurrency';
import PointDealPage from './app/PointDealPage';
import PointCompanyProfile from './app/PointCompanyProfile';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

const initPersonalAccountContainer = document.getElementById('onlog-personal-account-init');

if (initPersonalAccountContainer) {
  const initWidget = ReactDOM.createRoot(initPersonalAccountContainer);
  initWidget.render(<PointInitPersonalAccount />);
}

const initWidgetContainer = document.getElementById('onlog-widget-init');

if (initWidgetContainer) {
  const initWidget = ReactDOM.createRoot(initWidgetContainer);
  initWidget.render(<PointInit />);
}

const widgetContainer = document.getElementById('onlog-widget-container');

if (widgetContainer) {
  const mainWidget = ReactDOM.createRoot(widgetContainer);
  mainWidget.render(<PointWidget />);
}

const companyProfileContainer = document.getElementById('onlog-company-profile-container');

if (companyProfileContainer) {
  const companyProfile = ReactDOM.createRoot(companyProfileContainer);
  companyProfile.render(
    <Suspense fallback={<LinearProgress />}>
      <PointCompanyProfile />
    </Suspense>
  );
}

const initDealPageContainer = document.getElementById('onlog-deal-page-container');

if (initDealPageContainer) {
  const dealPage = ReactDOM.createRoot(initDealPageContainer);
  dealPage.render(
    <Suspense fallback={<LinearProgress />}>
      <PointDealPage />
    </Suspense>
  );
}

const widgetMenuContainer = document.getElementById('onlog-menu-widget-container');

if (widgetMenuContainer) {
  const menuWidget = ReactDOM.createRoot(widgetMenuContainer);
  menuWidget.render(<PointMenuWidget />);
}

const currencySelector = document.getElementById('currencySelector');
const currencyController = document.getElementById('currencyController');

if (currencySelector && currencyController) {
  const currencyDom = ReactDOM.createRoot(currencyController);
  currencySelector.addEventListener('change', (event) => {
    // @ts-ignore
    const currentCurrency = event.target.value;
    currencyDom.render(<PointCurrency currency={currentCurrency} />);
  });
}

const primaryLangSelector = document.getElementById('primaryLangSelector');
const primaryLangController = document.getElementById('primaryLangController');

if (primaryLangSelector && primaryLangController) {
  const currencyDom = ReactDOM.createRoot(primaryLangController);
  primaryLangSelector.addEventListener('change', (event) => {
    // @ts-ignore
    const primaryLanguageId = event.target.value;
    currencyDom.render(<PointPrimaryLang primaryLanguageId={primaryLanguageId} />);
  });
}

const secondaryLangSelector = document.getElementById('secondaryLangSelector');
const secondaryLangController = document.getElementById('secondaryLangController');

if (secondaryLangSelector && secondaryLangController) {
  const currencyDom = ReactDOM.createRoot(secondaryLangController);
  secondaryLangSelector.addEventListener('change', (event) => {
    // @ts-ignore
    const currentCurrency = event.target.value;
    currencyDom.render(<PointCurrency currency={currentCurrency} />);
  });
}

reportWebVitals();
